import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

export const changeLangObject = (value: LangObject[], newItem: LangObject): LangObject[] => {

    const temp = [...value]
    const langIndex = temp?.findIndex(i => i?.lang === newItem?.lang);

    if (langIndex === -1) return [...temp, newItem];

    temp[langIndex] = newItem;

    return temp;
}

export const makeBilingualLangObject = (value: string): LangObject[] => {

    return [
        {
            lang: 'ru',
            name: value
        },
        {
            lang: 'en',
            name: value
        },
    ];
}import {LangObject} from "@brg/api/dist/api-core/utils/lang-utils";

export const changeLangObject = (value: LangObject[], newItem: LangObject): LangObject[] => {

    const temp = [...value]
    const langIndex = temp?.findIndex(i => i?.lang === newItem?.lang);

    if (langIndex === -1) return [...temp, newItem];

    temp[langIndex] = newItem;

    return temp;
}

export const makeBilingualLangObject = (value: string): LangObject[] => {

    return [
        {
            lang: 'ru',
            name: value
        },
        {
            lang: 'en',
            name: value
        },
    ];
}